import { render } from "./UserAvatar.vue?vue&type=template&id=05be1a1f&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=05be1a1f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05be1a1f"]])

export default __exports__